import { render, staticRenderFns } from "./textarea-widget.vue?vue&type=template&id=5bc255ec&scoped=true"
import script from "./textarea-widget.vue?vue&type=script&lang=js"
export * from "./textarea-widget.vue?vue&type=script&lang=js"
import style0 from "./textarea-widget.vue?vue&type=style&index=0&id=5bc255ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc255ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc255ec')) {
      api.createRecord('5bc255ec', component.options)
    } else {
      api.reload('5bc255ec', component.options)
    }
    module.hot.accept("./textarea-widget.vue?vue&type=template&id=5bc255ec&scoped=true", function () {
      api.rerender('5bc255ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/textarea-widget.vue"
export default component.exports